import { render, staticRenderFns } from "./vote.vue?vue&type=template&id=ec152c5c&scoped=true"
import script from "./vote.vue?vue&type=script&lang=js"
export * from "./vote.vue?vue&type=script&lang=js"
import style0 from "./vote.vue?vue&type=style&index=0&id=ec152c5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec152c5c",
  null
  
)

export default component.exports